import { api, unwrap } from './client';

/**
 * Procurement API client.
 *
 * Backend wraps every response in ApiResponse<T>; always pass through unwrap().
 * Paths begin with /finance/procurement.
 */

export async function listProcurement(page = 0, size = 10) {
  const res = await api.get(`/finance/procurement/paginated/all?page=${page}&size=${size}`);
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listProcurementPaginated(page = 0, size = 10) {
  const res = await api.get(`/finance/procurement/paginated/all?page=${page}&size=${size}`);
  return unwrap(res);
}

export async function listMyProcurement(page = 0, size = 10) {
  const res = await api.get(`/finance/procurement/paginated/my?page=${page}&size=${size}`);
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listMyProcurementPaginated(page = 0, size = 10) {
  const res = await api.get(`/finance/procurement/paginated/my?page=${page}&size=${size}`);
  return unwrap(res);
}

export async function listProcurementFilter(params) {
  const queryString = new URLSearchParams({ page: 0, size: 10, ...params }).toString();
  const res = await api.get(`/finance/procurement/paginated/filter?${queryString}`);
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listProcurementFilterPaginated(params) {
  const queryString = new URLSearchParams(params).toString();
  const res = await api.get(`/finance/procurement/paginated/filter?${queryString}`);
  return unwrap(res);
}

export async function listProcurementByStatus(status, page = 0, size = 10) {
  const res = await api.get(`/finance/procurement/paginated/status/${status}?page=${page}&size=${size}`);
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listProcurementByCategory(category, page = 0, size = 10) {
  const res = await api.get(`/finance/procurement/paginated/category/${category}?page=${page}&size=${size}`);
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listProcurementByDepartment(department, page = 0, size = 10) {
  const res = await api.get(`/finance/procurement/paginated/department/${department}?page=${page}&size=${size}`);
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listProcurementByProject(projectId, page = 0, size = 10) {
  const res = await api.get(`/finance/procurement/paginated/project/${projectId}?page=${page}&size=${size}`);
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function getProcurement(id) {
  const res = await api.get(`/finance/procurement/${id}`);
  return unwrap(res);
}

/**
 * JSON variant — no file attached on creation.
 */
export async function createProcurement(payload) {
  const res = await api.post('/finance/procurement', payload);
  return unwrap(res);
}

export async function updateProcurement(id, payload) {
  const res = await api.put(`/finance/procurement/${id}`, payload);
  return unwrap(res);
}

/**
 * Multipart variant — backend expects:
 *   - `procurement` part: a Blob with type application/json containing the
 *                        JSON-serialised ProcurementRequestDto.
 *   - `file`        part: the binary file.
 *
 * Using a typed Blob (rather than a plain string) ensures Spring binds the
 * `procurement` request-part as JSON via its MappingJackson2HttpMessageConverter.
 */
export async function createProcurementWithFile(payload, file) {
  const fd = new FormData();
  fd.append(
    'procurement',
    new Blob([JSON.stringify(payload)], { type: 'application/json' }),
  );
  if (file) fd.append('file', file);
  const res = await api.post('/finance/procurement', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return unwrap(res);
}

export async function submitProcurement(id) {
  const res = await api.post(`/finance/procurement/${id}/submit`);
  return unwrap(res);
}
